import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor }  from "./store/store";
import OrganizationProvider from "./OrganizationProvider";
import { ConfigProvider } from "antd";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { orgThemes } from "components/Common/EnvVariables";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

const domainParts = window.location.hostname.split(".");
const subdomain = domainParts.length >= 2 ? domainParts[0] : "";

let theme = subdomain ? orgThemes[subdomain] : orgThemes.default;

root.render(
  <Provider store={store}>
    <PersistGate loading={<p>Loading</p>} persistor={persistor}>
      <OrganizationProvider>
      <ConfigProvider
        theme={theme}
      >
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>     
        </ConfigProvider>
      </OrganizationProvider>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

